import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RadioField from '../../../FormLegacy/FormFieldsV2/RadioField'

const EditEventsSchedule = ({ onChange, value, formName }) => {
  const { t } = useTranslation(['create-event'])
  const handleChange = (val) => {
    onChange({ target: { value: val } })
  }

  return (
    <React.Fragment>
      <div>{t('create-event:editEventsSchedule.description')}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'false'}
          label={t('create-event:editEventsSchedule.updateOnlyThisEvent')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'false'}
        />
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'future'}
          label={t('create-event:editEventsSchedule.updateAllFutureEvents')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'future'}
        />
        <RadioField
          type="radio"
          name={`${formName}-eventsToUpdate`}
          value={'true'}
          label={t('create-event:editEventsSchedule.updateAllEvents')}
          onChange={(e) => handleChange(e.target.value)}
          checked={String(value) === 'true'}
        />
      </div>
    </React.Fragment>
  )
}

EditEventsSchedule.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  formName: PropTypes.string,
}

export default EditEventsSchedule
